// extracted by mini-css-extract-plugin
export default {"cover_card":"Carousel_cover_card__x8yZe","cover_caption":"Carousel_cover_caption__A1Okq","cover_thumb":"Carousel_cover_thumb__criw2","mobile_drag":"Carousel_mobile_drag__eQA4W"};